export default {}; export const readFile = () => Promise.reject(new Error('node:fs/promises not available in browser'));